module.exports = __webpack_public_path__ + "static/img/hs_banner.22e27d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/hs_banner.png
// module id = 0GpG
// module chunks = 1